import { render } from "./LinkPreviewToggle.vue?vue&type=template&id=1ba6c5b8&ts=true"
import script from "./LinkPreviewToggle.vue?vue&type=script&lang=ts"
export * from "./LinkPreviewToggle.vue?vue&type=script&lang=ts"

import exportComponent from "/root/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__